<template>
  <div class="side-collect-box">
    <div class="header-wrapper">
      <xa-button text class="go-favorite-btn" @click="goMyFavorite">查看我的收藏</xa-button>
      <xa-select
        class="select-note-type"
        v-model="favoriteType"
        placeholder="个人收藏"
        size="small"
        @change="collectTypeChange"
      >
        <xa-option v-for="item in favoriteTypeOptions" :key="item.value" :label="item.label" :value="item.value">
        </xa-option>
      </xa-select>
      <i style="margin: 0 -25px; color: #aeaeae" class="iconfont web-icon_icon-xianxing-guanlian"></i>
      <xa-select
        class="select-note-type"
        v-model="favoriteId"
        placeholder="默认收藏夹"
        size="small"
        @change="collectIdChange"
      >
        <xa-option v-for="item in favorites" :key="item.id" :label="item.title" :value="item.id"> </xa-option>
      </xa-select>
      <xa-button text class="close-icon-btn" @click="closeWindow"><i class="el-icon-close"></i></xa-button>
    </div>
    <div class="collect-list" v-loading="loading">
      <ul class="list-wrapper" v-if="collectItems.length > 0">
        <li v-for="(collectItem, index) in collectItems" :key="index">
          <div class="collect-type-name-wrapper" :class="{ 'have-inquiry': isHaveInquiry }">
            <span class="collect-type-name" :style="{ background: collectItem.color }">
              {{ collectItem.typeName }}</span
            >
          </div>
          <div class="collect-title-wrapper">
            <div class="collect-title" @click="goItemLink(collectItem)">
              {{ collectItem.title }}{{ collectItem.type == 'interact' ? collectItem.timeLiness : '' }}
            </div>
            <span class="collect-time">{{ $common.formatDate(collectItem.createDatetime, 'YYYY-MM-DD') }}</span>
          </div>
        </li>
      </ul>
      <xa-pagination
        v-if="collectItems.length > 0"
        class="vxa-footer-page-pagination"
        mode="onlyPager"
        :currentPage="pageNum"
        :total="total"
        :page-size="pageSize"
        @currentChange="pageChange"
      ></xa-pagination>
      <vxa-no-info v-if="isNoInfo"></vxa-no-info>
    </div>
  </div>
</template>

<script>
export default {
  name: 'side-collect-box',
  data() {
    return {
      favoriteType: '个人收藏',
      favoriteTypeOptions: [
        { value: '个人收藏', label: '个人收藏' },
        { value: '团队收藏', label: '团队收藏' }
      ],
      favoriteId: '',
      favorites: [],
      collectItems: [],
      total: 0,
      pageNum: 1,
      pageSize: 10,
      userInfo: {},
      loading: true,
      isNoInfo: false,
      isHaveInquiry: false
    }
  },
  created() {
    this.userInfo = this.$storage.getUserInfo()
    this.$storage.isLogin() && this.getPersonDefaultFavorite()
    // 外部用户无查看团队收藏权限
    if ((this.$auth.isOuterUser() && this.userInfo.outerType != 1) || this.$auth.isIndependentDirectorUser()) {
      this.favoriteTypeOptions.splice(1, 1)
    }
  },
  destroyed() {
    window.onresize = null
  },
  methods: {
    closeWindow() {
      this.$emit('isShow')
    },
    goMyFavorite() {
      this.closeWindow()
      this.$router.push({ path: '/collections' })
    },
    getPersonDefaultFavorite() {
      this.$axios.user
        .getDefaultContent()
        .then(res => {
          const defaultCollect = res.data.returnObject || {}
          this.favoriteId = defaultCollect.id
          this.pageNum = 1
          this.getFavoriteContent()
          this.getPersonFavorite(defaultCollect)
        })
        .catch(err => {
          console.error(err)
          this.loading = false
        })
    },
    getTeamDefaultFavorite() {
      const params = {
        companyId: this.userInfo.companyId
      }
      if (!params.companyId) {
        return
      }
      this.$axios.teamFavourite
        .getTeamDefault(params)
        .then(res => {
          const defaultCollect = res.data.returnObject || {}
          this.favoriteId = defaultCollect.id
          this.pageNum = 1
          this.getFavoriteContent()
          this.getTeamFavorite(defaultCollect)
        })
        .catch(err => {
          console.error(err)
          this.loading = false
        })
    },
    getPersonFavorite(defaultCollect) {
      const params = {
        pageSize: 100,
        pageIndex: 1
      }
      this.$axios.user
        .getMyCollect(params)
        .then(res => {
          this.favorites = []
          const returnFavorites = res.data.returnObject?.list || []
          const favorites = [defaultCollect, ...returnFavorites]
          this.favorites = favorites.map(favorite => {
            return { id: favorite.id, title: favorite.favouriteName }
          })
        })
        .catch(err => {
          console.error(err)
          this.favorites = [{ id: defaultCollect.id, title: defaultCollect.favouriteName }]
        })
    },
    getTeamFavorite(defaultCollect) {
      const params = {
        companyId: this.userInfo.companyId,
        pageSize: 100,
        pageIndex: 1
      }
      this.$axios.teamFavourite
        .getFavourite(params)
        .then(res => {
          this.favorites = []
          const returnFavorites = res.data.returnObject?.list || []
          const favorites = [defaultCollect, ...returnFavorites]
          this.favorites = favorites.map(favorite => {
            return { id: favorite.id, title: favorite.favouriteName }
          })
        })
        .catch(err => {
          console.error(err)
          this.favorites = [{ id: defaultCollect.id, title: defaultCollect.favouriteName }]
        })
    },
    getFavoriteContent() {
      if (!this.favoriteId) {
        return
      }
      const params = {
        companyId: this.favoriteType === '团队收藏' ? this.userInfo.companyId : null,
        page: this.pageNum,
        rows: this.pageSize,
        isDesktop: 'y'
      }
      this.isNoInfo = false
      this.loading = true
      this.collectItems = []
      this.$axios.user
        .getCollectContent(params, this.favoriteId)
        .then(res => {
          this.collectItems = res.data.returnObject.collects || []
          this.collectItems.forEach(item => {
            this.transformCollectItem(item)
          })
          this.isHaveInquiry = this.collectItems.some(collect => collect.type === 'inquiry')
          this.total = res.data.returnObject.total
          if (this.collectItems.length === 0) {
            this.isNoInfo = true
          }
        })
        .catch(err => {
          console.error(err)
          this.isNoInfo = true
        })
        .finally(() => {
          this.loading = false
        })
    },
    transformCollectItem(item) {
      const type = item.type
      switch (type) {
        case 'law':
          this.$set(item, 'typeName', '法规')
          this.$set(item, 'color', '#90b8f4')
          // path /rules/:id
          this.$set(item, 'link', `/rules/${item.refId}`)
          break

        case 'sentiment':
          this.$set(item, 'typeName', '舆情')
          this.$set(item, 'color', 'rgb(255, 169, 240)')
          // path /rules/:id
          this.$set(item, 'link', `/sentiments/${item.refId}`)
          break
        case 'case':
          this.$set(item, 'typeName', '公告')
          this.$set(item, 'color', '#ffd091')
          // path:/affiches/:id
          this.$set(item, 'link', `/affiches/${item.refId}`)
          break
        case 'caselaw':
          this.$set(item, 'typeName', '案例')
          this.$set(item, 'color', '#ffa691')
          // path:/violation-cases/:id
          this.$set(item, 'link', `/violation-cases/${item.refId}`)
          break
        case 'report':
          this.$set(item, 'typeName', '研报')
          this.$set(item, 'color', '#8bdde4')
          // path: /reports/:id
          this.$set(item, 'link', `/reports/${encodeURIComponent(item.refId)}`)
          break
        case 'qa':
          this.$set(item, 'typeName', '问答')
          this.$set(item, 'color', '#f2aa94')
          // path: /inhope-FAQ/questions/:id
          this.$set(item, 'link', `/inhope-FAQ/questions/${item.refId}`)
          break
        case 'interact':
          this.$set(item, 'typeName', 'e互动')
          this.$set(item, 'color', '#ffa691')
          // path: /investor/questions/:id
          this.$set(item, 'link', `/investor/questions/${item.refId}`)
          break
        case 'publish': // IPO
        case 'STARM': // 科创板IPO
          this.$set(item, 'typeName', 'IPO')
          this.$set(item, 'color', '#ffddb0')
          if (item.publishType === 'KCBIPO') {
            // path: /STAR-ipo/:id
            this.$set(item, 'link', `/STAR-ipo/${item.refId}`)
          } else if (item.publishType === 'CYBIPO') {
            // path: /stib-ipo/:id
            this.$set(item, 'link', `/stib-ipo/${item.refId}`)
          } else if (item.publishType === 'BSEIPO') {
            // path: /bse-ipo/:id
            this.$set(item, 'link', `/bse-ipo/${item.refId}`)
          } else {
            // path: /ipo/:id
            this.$set(item, 'link', `/ipo/${item.refId}`)
          }
          break
        case 'inquiry':
          this.$set(item, 'typeName', '问询函件')
          this.$set(item, 'color', '#9aa7db')
          // path: /inquiry-letters/:id
          this.$set(item, 'link', `/inquiry-letters/${item.refId}`)
          break
      }
    },
    collectTypeChange(val) {
      this.loading = true
      if (val === '个人收藏') {
        this.getPersonDefaultFavorite()
      }
      if (val === '团队收藏') {
        this.getTeamDefaultFavorite()
      }
    },
    collectIdChange() {
      this.pageNum = 1
      this.collectItems = []
      this.getFavoriteContent()
    },
    goItemLink(collectItem) {
      if (!collectItem.link) {
        return
      }
      this.$common.openWindow(collectItem.link)
    },
    pageChange(val) {
      this.pageNum = val
      this.collectItems = []
      this.getFavoriteContent()
    }
  }
}
</script>

<style lang="scss" scoped>
.side-collect-box {
  height: 100%;
  .header-wrapper {
    padding: 0 15px;
    width: 100%;
    height: 45px;
    line-height: 45px;
    border-bottom: 1px solid #e3e3e3;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .go-favorite-btn {
      color: #666;
      font-size: 14px;
      &:hover {
        color: #ffb148;
      }
    }
    .select-note-type {
      width: 112px;
      /deep/ .el-select {
        .el-input__inner {
          width: 112px;
          font-size: 12px;
        }
      }
    }
    .close-icon-btn {
      color: #8d8d8d;
      font-size: 20px;
      &:hover {
        color: #ffb148;
      }
    }
  }
  .collect-list {
    height: calc(100% - 45px);
    .list-wrapper {
      height: calc(100% - 70px);
      overflow: auto;
      li {
        font-size: 14px;
        color: #323232;
        line-height: 20px;
        display: flex;
        align-items: flex-start;
        padding: 12px 15px 0px;
        &:hover {
          transition: all 0.3s;
          background-color: #f7f7f7;
        }
        .collect-type-name-wrapper {
          width: 58px;
          padding-right: 8px;
          &.have-inquiry {
            width: 70px;
          }
          .collect-type-name {
            display: inline-block;
            padding: 0 5px;
            height: 20px;
            line-height: 20px;
            text-align: center;
            color: #fff;
            font-size: 12px;
            border-radius: 2px;
          }
        }
        .collect-title-wrapper {
          flex: 1;
          padding-bottom: 12px;
          display: flex;
          justify-content: space-between;
          border-bottom: 1px solid rgb(227, 227, 227);
          .collect-title {
            cursor: pointer;
            flex: 1;
            padding-right: 8px;
            transition: all 0.3s;
            &:hover {
              text-decoration: underline;
              color: #ffb148;
            }
          }
          .collect-time {
            flex-shrink: 0;
            display: inline-block;
            width: 75px;
            font-size: 12px;
            color: #8d8d8d;
          }
        }
      }
    }
    /deep/ .el-pagination {
      margin-top: 20px;
      text-align: center;
    }
  }
}
</style>
